import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import ManageInstitution from '../manageInstitutions/manageInstitution.vue'

export default {
  data: () => ({
    visible: false,
    totalItensOnPage: 0,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    expanded: [],
    institutions: [],
    currentInstitution: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      Name: null,
      Initials: null,
      workshopType: null,
    },
    workshopTypes: ['Engenharia clínica', 'Manutenção predial'],
    institutionName: null,
    institutionInitials: null,
    workshopType: null,
    message: '',
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Instituição',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Sigla',
        align: 'center',
        value: 'initials',
        sortable: false,
      },
      {
        text: 'Unidades',
        align: 'center',
        value: 'unidades',
        sortable: false,
      },
      {
        text: 'Oficina',
        align: 'center',
        value: 'workshop',
      },
      {
        text: 'Cadastro',
        align: 'center',
        value: 'createdAt',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 300,
      },
    ],
    headersMobile: [
      {
        text: 'Instituição',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Cadastro',
        align: 'center',
        value: 'createdAt',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    user: {},
    institution: {},
  }),

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.updateTable()
  },

  components: {
    ManageInstitution,
  },

  methods: {
    addInstitution() {
      this.currentInstitution = null
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editInstitution(institution) {
      this.dialogKey = !this.dialogKey
      this.currentInstitution = institution
      this.dialog = true
    },

    closeDialog() {
      this.dialogKey = !this.dialogKey
      this.dialog = false
      this.editDialog = false

      this.updateTable()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.Name = this.institutionName
      this.filter.Initials = this.institutionInitials
      this.filter.workshopType = this.workshopTypes.indexOf(this.workshopType)

      this.updateTable()
    },

    getDepartmentTypes(departmentTypes) {
      return departmentTypes
        ? departmentTypes
            .map((x) => {
              switch (x) {
                case 0:
                  return 'Engenharia clínica'
                case 1:
                  return 'Manutenção predial'
                default:
                  return 'Sem registro'
              }
            })
            .join(', ')
        : 'Sem registro'
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    async updateTable() {
      this.loading = true
      await this.apiService
        .post('institution/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.institutions = response.content.institutions
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.institutions.length
          this.loading = false
        })
    },

    async editStatus(institution) {
      institution.status = institution.status == 0 ? 1 : 0
      this.currentInstitution = JSON.parse(localStorage.getItem('institution'))

      await this.apiService
        .post('institution/edit', institution)
        .then((response) => {
          if (institution.id == this.currentInstitution.id) {
            this.getInstitution(institution.id)
          }
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async setMigrated(institution) {
      const migrated = !institution.migratedToV2

      await this.apiService
        .post('institution/set-migrated', {
          institutionId: institution.id,
          migrated,
        })
        .then(() => {
          this.$set(institution, 'migratedToV2', migrated)
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getInstitution(institutionId) {
      await this.apiService
        .get(`institution/${institutionId}`)
        .then((response) => {
          const institution = response.content
          localStorage.removeItem('institution')
          this.$store.commit(
            'SET_INSTITUTION_USER',
            JSON.stringify(institution)
          )
        })
    },

    isInactive(value) {
      return value.status == 1 ? 'inactive' : ''
    },

    reset() {
      this.institutionName = null
      this.institutionInitials = null
      this.workshopType = null

      this.filter = {
        institutionName: null,
        institutionInitials: null,
        page: 1,
        pageSize: this.pageSize,
        workshopType: null,
      }

      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = this.page
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
